export var ShapeType;
(function (ShapeType) {
    ShapeType["Rectangle"] = "rectangle";
    ShapeType["Ellipse"] = "ellipse";
})(ShapeType || (ShapeType = {}));
